// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"67b159c3","453":"83317f59","627":"6e91048d","738":"32ea6b66","923":"913014ac"}[chunkId] + ".chunk.js";
};